$(function () {
  const mySwiper5 = new Swiper('.product-item__image .swiper', {
    /*loop: true,*/
    slidesPerView: 1,
    spaceBetween: 0,
    grabCursor: true,
	observer: true,
	observeParents: true,
    navigation: {
      nextEl: '.product-item__image .swiper-button-next',
      prevEl: '.product-item__image .swiper-button-prev',
    },
  });

});